<div class="iframe-container">
  <iframe [src]="url | safe" frameborder="0" allowfullscreen allow="autoplay"></iframe>
</div>
